import React from "react";
import { styled } from "@mui/material/styles";
import { Paper } from "@mui/material";

import { backgroundImage, backgroundSize, BORDERRADIUS as borderRadius } from "@fedsim/constants";

// const getBackgroundColor = (theme, dark) => dark && theme.palette.mode === "dark" ? "dark" : "light"
// const getTextColor = (theme, dark) => dark && theme.palette.mode === "dark" ? '#000' : '#000'
// const getBackdropFilter = (theme) => theme.palette.mode === "dark" ? "blur(10px)" : "blur(20px)"

export const DottedPaper = styled((props) => <Paper {...props}
    elevation={2} />)(
        ({ theme, dark = false, sx = {} }) => ({
            ...sx,
            padding: theme.spacing(.8),
            // color: getTextColor(theme, dark),
            // backgroundColor: getBackgroundColor(theme, dark),
            // backdropFilter: getBackdropFilter(theme),
            backgroundImage,
            backgroundSize,
            borderRadius,
            // color: theme => dark && theme.palette.mode === "dark" ? '#999' : '#333',
            // backgroundColor: dark && theme.palette.mode === "dark"
            //     ? "rgba(0, 0, 0, .5)" : theme.palette.mode === "dark" ? "rgba(0, 0, 0, .9)" :
            //         theme.palette.mode === "light" ? "rgba(25, 25, 25, 0.2)" : "rgba(255, 255, 255, .9)",
        })
    );

export default DottedPaper;
